const asArray = (value) => Array.isArray(value) ? value : [];

const clone = (value) => JSON.parse(JSON.stringify(value));

export const normalizePresentationState = (state) => ({
  measurements: asArray(state?.measurements).map(clone),
  rois: asArray(state?.rois).map(clone),
  annotations: asArray(state?.annotations).map(clone),
});

export const serializePresentationState = ({ measurements = [], rois = [], annotations = [] } = {}) => normalizePresentationState({
  measurements,
  rois,
  annotations,
});

export const isPresentationStateEmpty = (state) => {
  const normalized = normalizePresentationState(state);
  return normalized.measurements.length === 0 && normalized.rois.length === 0 && normalized.annotations.length === 0;
};


export const presentationStateSyncKey = (state) => JSON.stringify(normalizePresentationState(state));
